module.exports = __webpack_public_path__ + "assets/img/supplier_level2.d57c112c.svg";